import request from './request'

// 查询代理用户信息
export const getAgentUserInfo = () => {
  return request({
    url: '/carbon-report/private/user/report/agent/info',
    method: 'get',
  })
}

export const configDetail = (params: any) => {
  return request({
    url: '/agent/configDetail',
    method: 'get',
    params,
  })
}
// 代理详情搜索
export const agentDetailSearch = (params: any) => {
  return request({
    url: '/agent/agentDetailSearch',
    method: 'get',
    params,
  })
}

// 获取代理报表列表
export const agentReportList = (params: any) => {
  return request({
    url: '/agent/agentReportList',
    method: 'get',
    params,
  })
}

// 获取待结算收益金额
export const getAgentUnsettledAmount = () => {
  return request({
    url: '/carbon-promotion/private/user/agent/unsettled',
    method: 'get',
  })
}
// 查询团队下级代理信息
export const getAgentTeamInfo = (params: any) => {
  return request({
    url: '/carbon-report/private/user/report/agent/team/search',
    method: 'get',
    params,
  })
}

//C端-昨日概览
export const getAgentOverview = (params: any) => {
  return request({
    url: '/carbon-report/private/user/report/agent/summary',
    method: 'get',
    params,
  })
}

//我的团队详情
export const getAgentTeamDetail = (params: any) => {
  return request({
    url: '/carbon-report/private/user/report/agent/team/detail',
    method: 'get',
    params,
  })
}
